/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateSpaceRequest } from '../../models/update-space-request';
import { UpdateSpaceResult } from '../../models/update-space-result';

export interface ApiSpacesIdPut$Params {
  id: string;
      body?: UpdateSpaceRequest
}

export function apiSpacesIdPut(http: HttpClient, rootUrl: string, params: ApiSpacesIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateSpaceResult>> {
  const rb = new RequestBuilder(rootUrl, apiSpacesIdPut.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateSpaceResult>;
    })
  );
}

apiSpacesIdPut.PATH = '/api/Spaces/{id}';
